<template>
  <div class="container card-container">
    <div class="card md-12">
      <div class="card-body">
        <h5 class="card-title">
          {{ $t("Setting.CustomerCard.CustomerInfo") }}
        </h5>
        <p class="card-description">
          {{ $t("Setting.CustomerCard.CustomerInfoDetail") }}
        </p>
        <div class="card-text">
          <div class="form-row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="customer-id">
                  {{ $t("Setting.CustomerCard.Label.CustomerId") }}
                </label>
                <input
                  type="text"
                  id="customer-id"
                  class="form-control"
                  :value="editCustomerSettingData.customerId"
                  readonly
                >
              </div>
            </div>
            <div class="col-md-9">
              <div class="form-group">
                <label for="customer-name">
                  {{ $t("Setting.CustomerCard.Label.CustomerName") }}
                </label>
                <input
                  type="text"
                  id="customer-name"
                  class="form-control"
                  v-model="editCustomerSettingData.name"
                >
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <div class="form-group">
                <VSelectbox
                  :items="nationItems"
                  select-id="select-country"
                  :placeholder="$t('Setting.CustomerCard.Label.CountryPlaceholder')"
                  @selectedData="editCustomerSettingData.country = $event"
                >
                  <template #label>
                    {{ $t("Setting.CustomerCard.Label.Country") }}
                  </template>
                </VSelectbox>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="post-code">
                  {{ $t("Setting.CustomerCard.Label.PostCode") }}
                </label>
                <input
                  type="text"
                  id="post-code"
                  class="form-control"
                  :placeholder="$t('Setting.CustomerCard.Label.PostCodePlaceholder')"
                  v-model="editCustomerSettingData.postCode"
                >
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="address">
                  {{ $t("Setting.CustomerCard.Label.Address") }}
                </label>
                <input
                  type="text"
                  id="address"
                  class="form-control"
                  :placeholder="$t('Setting.CustomerCard.Label.AddressPlaceholder')"
                  v-model="editCustomerSettingData.address"
                >
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="representative-user-name">
                  {{ $t("Setting.CustomerCard.Label.RepresentativeUser") }}
                </label>
                <input
                  type="text"
                  id="representative-user-name"
                  class="form-control"
                  :placeholder="$t('Setting.CustomerCard.Label.RepresentativeUserPlaceholder')"
                  v-model="editCustomerSettingData.representativeUserName"
                >
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="phone-number">
                  {{ $t("Setting.CustomerCard.Label.PhoneNumber") }}
                </label>
                <input
                  type="tel"
                  id="phone-number"
                  class="form-control"
                  :placeholder="$t('Setting.CustomerCard.Label.PhoneNumberPlaceholder')"
                  v-model="editCustomerSettingData.phone"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="isAbejaAdmin"
      class="card md-12"
    >
      <div class="card-body">
        <h5 class="card-title">
          {{ $t("Setting.CustomerCard.AbejaAdminInfo") }}
        </h5>
        <div class="card-text">
          <div class="form-row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="extarnal-service-id">
                  {{ $t("Setting.CustomerCard.Label.ExternalServiceId") }}
                </label>
                <input
                  type="text"
                  id="extarnal-service-id"
                  class="form-control"
                  :placeholder="$t('Setting.CustomerCard.Label.ExternalServiceIdPlaceholder')"
                  v-model="editCustomerSettingData.externalServiceId"
                >
              </div>
            </div>
            <div class="col-md-6">
              <VSelectbox
                :items="purchaseTypeItems"
                select-id="select-purchase-type"
                :placeholder="$t('Setting.CustomerCard.Label.PurchaseTypePlaceholder')"
                @selectedData="editCustomerSettingData.purchaseType = $event"
              >
                <template #label>
                  {{ $t("Setting.CustomerCard.Label.PurchaseType") }}
                </template>
              </VSelectbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VSelectbox from '@/components/VSelectbox'

import { NATIONS_LIST } from '@/config/constants'
import { mapState } from 'vuex'

export default {
  components: {
    VSelectbox
  },
  props: {
    customerSettingData: {
      type: Object,
      default: () => ({
        customerId: null,
        name: '',
        country: '',
        address: '',
        postCode: '',
        phone: '',
        representativeUserName: '',
        externalServiceId: '',
        purchaseType: ''
      })
    }
  },
  data: () => ({
    editCustomerSettingData: {
      country: ''
    }
  }),
  computed: {
    ...mapState('auth', [
      'isAbejaAdmin'
    ]),
    nationItems() {
      return NATIONS_LIST.map((arr) => {
        return {
          text: this.$t(`Nations.${arr.text}`),
          value: arr.value,
          selected: arr.value === this.editCustomerSettingData.country
        }
      })
    },
    purchaseTypeItems() {
      return [
        'DirectSales',
        'PartnerSales',
        'PartnerReferral',
        'Self'
      ].map((arr) => ({
        text: this.$t(`Setting.Purchase.${arr}`),
        value: arr,
        selected: arr === this.editCustomerSettingData.purchaseType
      }))
    }
  },
  watch: {
    customerSettingData: {
      handler: function(val, _) {
        this.editCustomerSettingData = Object.assign({}, val)
      },
      deep: true
    },
    editCustomerSettingData: {
      handler: function(val, old) {
        this.updateData(val, old)
      },
      deep: true
    }
  },
  methods: {
    updateData(val, old) {
      if (Object.keys(old).length < 2) return null
      this.$emit('updateEditData', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  .card + .card {
    margin-top: 12px;
  }
}
</style>
